import * as React from 'react'
import { FC } from 'react'
import { ILeadOppProduct } from '@user/store/leadOppProducts/typings'
import { ITemplateDetail } from '@user/store/agreements/typings'
import { TemplateError } from '../../typings'

import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import { useTheme } from '@mui/material/styles'

const styles = {
  text: {
    fontSize: '14px',
    fontWeight: '500',
  },

  link: {
    color: '#1265a9',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
}

interface Props {
  isLoading: boolean
  openServicesDrawer: () => void
  services: ILeadOppProduct[]
  template: ITemplateDetail | null
  templateError: TemplateError
}

export const ErrorMessaging: FC<Props> = (props) => {
  const {
    templateError: { exceedsServiceSlots, exceedsServiceLocations },
    isLoading,
    openServicesDrawer,
    template,
  } = props

  const areServiceSlotsInvalid =
    !isLoading && template && exceedsServiceSlots && !exceedsServiceLocations

  const areServiceLocationsInvalid =
    !isLoading && template && exceedsServiceLocations

  const errorOccurred = areServiceSlotsInvalid || areServiceLocationsInvalid
  const theme = useTheme()
  return (
    <>
      <Box sx={{ marginTop: theme.spacing(1) }}>
        {errorOccurred && (
          <Box>
            <Alert
              sx={{
                display: 'flex',
                alignItems: 'start',
              }}
              severity="error"
            >
              <Box mb={0.5}>
                <AlertTitle
                  sx={{
                    fontSize: '16px',
                    color: '#541313',
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    sx={{
                      lineHeight: '24px',
                      fontWeight: '600',
                    }}
                    color="#541313"
                  >
                    Insufficient Space on Template
                  </Typography>
                </AlertTitle>
              </Box>
              {areServiceSlotsInvalid ? (
                <Box>
                  <Typography variant="body2">
                    The template selected does not have enough slots for the
                    services added.
                  </Typography>
                </Box>
              ) : (
                <Box>
                  <Typography variant="body2">
                    Agreement Template Does Not Support Multiple Service
                    Locations
                  </Typography>
                </Box>
              )}
            </Alert>

            <Box
              sx={{
                marginTop: theme.spacing(1),
                marginLeft: theme.spacing(0.9),
              }}
            >
              <Typography variant="subtitle3">
                Select another template or{' '}
                <Typography
                  variant="subtitle3"
                  component={'span'}
                  sx={styles.link}
                  onClick={openServicesDrawer}
                >
                  Click here
                </Typography>{' '}
                to edit the Services.
              </Typography>
            </Box>
          </Box>
        )}
      </Box>
    </>
  )
}

ErrorMessaging.displayName = 'ErrorMessaging'
